import { FC, ReactNode } from 'react'

import { useSectionNav } from 'hooks/useSectionNav'
import { NavButton } from '../nav-button'
import { MobileHeading, StyledSection } from './styled'

type Props = {
  children: ReactNode
  hasNextButton?: boolean
  menuTitle?: string
  menuHidden?: boolean
  isIntro?: boolean
}

export const Section: FC<Props> = ({
  children,
  hasNextButton,
  menuTitle,
  menuHidden,
  isIntro,
}) => {
  const { handlePrevClick, thisSection } = useSectionNav(menuTitle)

  return (
    <StyledSection
      $isIntro={isIntro}
      {...(menuTitle ? { 'data-menu-title': menuTitle } : null)}
      {...(menuHidden ? { 'data-menu-hidden': true } : null)}
    >
      {hasNextButton && (
        <NavButton
          isCurrent={thisSection?.isActive ?? false}
          onClick={handlePrevClick}
        />
      )}

      {!menuHidden && !!menuTitle && <MobileHeading>{menuTitle}</MobileHeading>}

      {children}
    </StyledSection>
  )
}
